const setScrollPadding = () =>{
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const header = document.querySelector('.ume-intra-navbar');
    if(typeof header !== 'undefined' && header !== null){

        let headerHeight = header.offsetHeight;


        document.documentElement.style.setProperty('--header-height', headerHeight + 'px');

        document.documentElement.style.setProperty('--scroll-padding-height', headerHeight + 'px')
    }

}
export default setScrollPadding;